var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('general-table',{ref:"countriesTable",attrs:{"api-url":_vm.apiUrl,"delete-content":false,"block-content":false,"edit-content":false,"view-content":false,"columns":_vm.columns,"type":_vm.type}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }